import { dt } from 'oderon-commons/src/formatters'
import { preProcessSpec } from 'oderon-commons/src/tables'

export const defCodes = [
  'id',
  'name',
  'label',
  'tags',
  'url',
  'internalIp',
  'internalPort',
  'clientCount'
]

export const fullSpec = preProcessSpec({
  defCodes,
  columns: [
    {
      t: 'ID|',
      d: 'id',
      w: 80,
      code: 'id',
      sortBy: 'id',
      selectable: true
    },
    {
      t: 'Ind.|',
      code: 'color',
      selectable: true,
      d: row => {
        return {
          value: row.color || 'grey',
          iconText: 'mdi-square-rounded',
          iconClass: row.color + '--text icon-small'
        }
      },
      sortBy: 'color'
    },
    {
      t: '|Código',
      code: 'name',
      sortBy: 'name',
      d: 'name'
    },
    {
      t: '|Nome',
      d: 'label'
    },
    {
      t: 'Paused?',
      d: 'isPaused',
      selectable: true
    },
    {
      t: 'Ignored?',
      d: 'isIgnored',
      selectable: true
    },

    {
      t: 'Tags',
      d: 'extraInfo.tags',
      code: 'tags',
      sortBy: 'extraInfo.tags',
      selectable: true
    },
    {
      t: 'URL',
      d: 'url',
      sortBy: 'url',
      selectable: true
    },
    {
      t: 'IP Interno|',
      d: 'extraInfo.internalIp',
      code: 'internalIp',
      sortBy: 'extraInfo.internalIp',
      selectable: true
    },
    {
      t: 'Porta|',
      d: 'extraInfo.internalPort',
      code: 'internalPort',
      sortBy: 'extraInfo.internalPort',
      selectable: true
    },
    {
      t: 'Mod. Assoc.|',
      d: 'associatedClientCount',
      sortBy: 'associatedClientCount',
      selectable: true
    },
    {
      t: 'Mod. Totais|',
      d: 'clientCount',
      sortBy: 'clientCount',
      selectable: true
    },

    {
      t: 'Criada em|',
      d: 'createdAt',
      sortBy: 'createdAt',
      w: 220,
      code: 'createdAt',
      selectable: true,
      f: dt
    },

    {
      t: 'Atualizada em|',
      d: 'updatedAt',
      sortBy: 'updatedAt',
      w: 220,
      code: 'updatedAt',
      selectable: true,
      f: dt
    },

    {
      t: 'Observações',
      d: 'comments',
      code: 'comments',
      sortBy: 'comments',
      selectable: true
    }
  ]
})
